// Borrower Context Actions

export class GetBorrowerContext {
    static readonly type = '[Borrower Context] Get';
    constructor(public borrowerId: number) {}
}
